// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","logo":"App_logo__7Edbg","logo-spin":"App_logo-spin__62DwI","header":"App_header__fhC8n","main":"App_main__nhgh3","link":"App_link__kpF6Q"};